var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 13.641H21.5163V11.3885L23.4614 12.5149L23.9777 11.6265L22.0322 10.5L23.9777 9.37363L23.4614 8.48521L21.5163 9.61163V7.35909H20.4844V9.61163L18.5392 8.48521L18.023 9.37363L19.9684 10.5L18.023 11.6265L18.5392 12.5149L20.4844 11.3885V13.641ZM3.05174 22.8848C2.51469 22.8848 2.0663 22.7049 1.70658 22.3452C1.34685 21.9855 1.16699 21.5371 1.16699 21V7.00005C1.16699 6.46299 1.34685 6.0146 1.70658 5.65488C2.0663 5.29516 2.51469 5.1153 3.05174 5.1153H24.9489C25.486 5.1153 25.9344 5.29516 26.2941 5.65488C26.6538 6.0146 26.8337 6.46299 26.8337 7.00005V21C26.8337 21.5371 26.6538 21.9855 26.2941 22.3452C25.9344 22.7049 25.486 22.8848 24.9489 22.8848H3.05174ZM10.5003 16.6026C11.308 16.6026 11.9961 16.3184 12.5645 15.75C13.1328 15.1817 13.417 14.4936 13.417 13.6859C13.417 12.8782 13.1328 12.1902 12.5645 11.6218C11.9961 11.0534 11.308 10.7693 10.5003 10.7693C9.6926 10.7693 9.00456 11.0534 8.4362 11.6218C7.86784 12.1902 7.58366 12.8782 7.58366 13.6859C7.58366 14.4936 7.86784 15.1817 8.4362 15.75C9.00456 16.3184 9.6926 16.6026 10.5003 16.6026ZM3.75174 21.7181H17.2489C16.4322 20.6635 15.4391 19.8165 14.2695 19.1771C13.0999 18.5378 11.8435 18.2181 10.5003 18.2181C9.1571 18.2181 7.9007 18.5378 6.73112 19.1771C5.56153 19.8165 4.56841 20.6635 3.75174 21.7181Z",
    fill: "#ADC9FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmergency);
export default __webpack_public_path__ + "static/media/contact_emergency.2d47387730cd836b5cb1b7ad5a5047d0.svg";
export { ForwardRef as ReactComponent };